<template>
    <MapViewer
        :class="`o-terminal-map-controller terminal-map-controller ${appCustomClasses}`"
        :map-data="getMvData"
        :active-view="activeView"
        :is-reactive="false"
        ref="mapViewer"
        @ready="onMapReady"
    >
        <OMapGuideViews @changeView="setActiveView" />
        <OMapExplorationViews @changeView="setActiveView" />
        <OMapShowreelViews @changeView="setActiveView"/>
        <OMapPosterViews @changeView="setActiveView" />
    </MapViewer>
</template>

<script>
import { mapGetters } from 'vuex';
import OMapGuideViews from "../o-map-guide-views/o-map-guide-views";
import MapViewer from "../../../shared/components/map-viewer/map-viewer";
import OMapExplorationViews from "../o-map-exploration-views/o-map-exploration-views";
import OMapShowreelViews from "@/components/organisms/o-map-showreel-views/o-map-showreel-views";
import {
    REMOVE_PATH,
    MAP_SHOW_FLOOR,
    MAP_SHOW_OBJECT,
    SET_ACTIVE_VIEW,
    SET_GYROSCOPE_STATE,
    SET_NORMALIZED_ZOOM,
} from "@/shared/components/map-viewer/constants/map-commands";
import OMapPosterViews from "@/components/organisms/o-map-poster-views/o-map-poster-views";

export default {
    name: "ODMapController",
    components: {
        OMapPosterViews,
        OMapShowreelViews,
        OMapExplorationViews,
        MapViewer,
        OMapGuideViews,
    },
    data() {
        return {
            activeView: 'ShowreelView',
            availableViews:[
                'ShowreelView',
                'OutdoorView',
                'FloorSelection',
                'LevelView'
            ],
        }
    },
    computed: {
        ...mapGetters([
            'getMvData'
        ]),
        appCustomClasses() {
            return this.$route.name == 'web.integration.catalogue.start' || this.$route.name == 'web.integration.store.info' ?
                'app-adopt' : ''
        }
    },
    methods:{
        initEventListeners() {

            this.$bus.$on(REMOVE_PATH, this.onRemovePath);
            this.$bus.$on(SET_ACTIVE_VIEW, this.setActiveView);
        },
        deactivateEventListeners() {
            this.$bus.$off(REMOVE_PATH, this.onRemovePath);
            this.$bus.$off(SET_ACTIVE_VIEW, this.setActiveView);

        },
        onMapReady() {
            this.$store.commit('setMapLoading', false);
        },
        setActiveView(activeView){
            this.activeView = activeView
        },
        onRemovePath(){
            this.$refs.mapViewer.viewApi.remove_path();
            this.$refs.mapViewer.viewApi.restore_base_color();
            this.setActiveView('ExplorationViews');
        },
    },
    mounted() {
        this.initEventListeners();
    },
    watch:{
        '$route.query.mv': {
            handler(mapViewName){
                if(mapViewName){
                    this.activeView = mapViewName;
                }
            },
            immediate: true
        }
    },
    beforeDestroy() {
        this.deactivateEventListeners();
    }

}
</script>

<style lang="scss">
@import "d-map-controller";
</style>
